<template>
  <div class="addressDetail">
    <el-button @click="back" class="back-button">{{
      $t("B2C.back")
    }}</el-button>
    <div class="address-title">
      <span v-if="form.URId">{{ $t("shipping.editAddress") }}</span>
      <span v-else>{{ $t("shipping.create") }}</span>
    </div>
    <el-form :model="form" :rules="rules" ref="form" class="form-box">
      <el-form-item :label="$t('shipping.receivingName')" prop="ReceivingName">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.ReceivingName"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shipping.phoneNumber')" prop="PhoneNumber">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.PhoneNumber"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shipping.country')" prop="CountryCode">
        <el-select
          v-model="form.CountryCode"
          :placeholder="$t('B2C.select')"
          filterable
          clearable
        >
          <el-option
            v-for="item in countryList"
            :key="item.CountryA2"
            :label="item.CountryEnglishName"
            :value="item.CountryA2"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('shipping.city')" prop="City">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.City"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shipping.postalCode')" prop="PostalCode">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.PostalCode"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shipping.addressDetail')">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.ReceivingAddress"
          type="textarea"
          :autosize="{ minRows: 4 }"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shipping.isDefault')">
        <el-radio-group v-model="form.IsDefult">
          <el-radio :label="0">{{ $t("shipping.no") }}</el-radio>
          <el-radio :label="1">{{ $t("shipping.yes") }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="handleSubmit" class="submit-btn" round>{{
      $t("shipping.submit")
    }}</el-button>
  </div>
</template>
<script>
export default {
  name: "addressDetail",
  data() {
    return {
      products: [],
      countryList: [],
      isOrder:false,
      form: {
        URId: "",
        ReceivingName: "",
        PhoneNumber: "",
        CountryCode: "",
        City: "",
        PostalCode: "",
        ReceivingAddress: "",
        IsDefult: 0
      },
      rules: {
        ReceivingName: [
          {
            required: true,
            message:
              this.$t("B2C.input") + " " + this.$t("shipping.receivingName")
          }
        ],
        PhoneNumber: [
          {
            required: true,
            message:
              this.$t("B2C.input") + " " + this.$t("shipping.phoneNumber")
          }
        ],
        CountryCode: [
          {
            required: true,
            message: this.$t("B2C.select") + " " + this.$t("shipping.country")
          }
        ],
        City: [
          {
            required: true,
            message: this.$t("B2C.select") + " " + this.$t("shipping.city")
          }
        ],
        PostalCode: [
          {
            required: true,
            message: this.$t("B2C.input") + " " + this.$t("shipping.postalCode")
          }
        ]
      }
    };
  },
  mounted() {
    const { URId, Products, IsOrder } = this.$route.query;
    this.form.URId = URId || "";
    this.products = Products || [];
    this.isOrder = IsOrder;
    this.getCountrys().then(success => {
      if (success) {
        if (this.form.URId) {
          this.loadUsersReceivingInfo();
        }
      }
    });
  },
  methods: {
    handleSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let param = { ...this.form };

          this.$api.cUser
            .addUsersReceiving(param)
            .then(() => {
              this.$message({
                message: this.$t("B2C.success"),
                type: "success"
              });
              this.back();
            })
            .catch(err => {
              this.$message.error(err.message);
            });
        } else {
          return false;
        }
      });
    },
    loadUsersReceivingInfo() {
      return new Promise(resolve => {
        let param = {
          URId: this.form.URId
        };
        this.$api.cUser
          .loadUsersReceivingInfo(param)
          .then(res => {
            var data = res.data || {};
            this.form = data;

            resolve(true);
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      });
    },
    getCountrys() {
      return new Promise(resolve => {
        let param = {};
        this.$api.cUser
          .getCountrys(param)
          .then(res => {
            var data = res.data || [];
            this.countryList = data;

            resolve(true);
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      });
    },
    back() {
      if (this.isOrder) {
        this.$router.replace("/cUser/shippingAddress");
      } else {
        this.$router.back(-1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.addressDetail {
  padding-bottom: 10%;
  background: rgb(246, 246, 246);

  .back-button {
    left: 3%;
    top: 4%;
    font-size: 14px;
    position: absolute;
    z-index: 11;
  }
  .submit-btn {
    min-width: 300px;
    display: block;
    margin: 30px auto 0;
  }
  .address-title {
    width: 50%;
    font-size: 25px;
    margin: auto;
    text-align: center;
    padding: 30px;
    background: #fff;
    margin-bottom: 20px;
  }
  .form-box {
    width: 50%;
    margin: auto;
    padding: 30px;
    background: #fff;

    ::v-deep .el-select {
      width: 100%;
    }

    .el-radio-group {
      margin-left: 30px;
    }

    .breadcrumb.inline {
      display: inline-block;
      margin-right: 16px;
      font-weight: normal;
    }
    .textfield {
      display: inline-block;
      width: 100%;
      &.mini {
        width: 80px;
        min-width: 80px;
      }

      &.small {
        min-width: 160px;
      }

      .prefix {
        font-style: normal;
        margin-left: 10px;
        color: black;
      }
      .suffix {
        font-style: normal;
        margin-right: 10px;
        color: black;
      }
    }
    .small-textarea {
      display: inline-block;
      width: auto;
      min-width: 380px;
    }
    .tBUrlInput {
      display: inline-block;
      width: auto;
      min-width: 500px;
    }
    .textareatBUrl {
      word-wrap: break-word;
      width: 70%;
    }
    .desc {
      font-size: 12px;
      color: #989898;
      margin-left: 10px;
      &.wrap {
        display: block;
        line-height: 24px;
        margin-left: 0;
      }
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
    .button-new-keyword {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-keyword {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }

    .gray-box {
      margin-top: 16px;
      padding: 30px 20px;
      background-color: #fbf9f9;
      border-radius: 13px;
    }
    .freight-desc-box {
      font-size: 12px;
      line-height: 12px;
      color: black;

      > p {
        margin-top: 12px;
        margin-bottom: 0;

        span {
          color: #22b196;
        }
      }
    }
    .normal-checkbox {
      font-weight: normal;
    }
    .tag-checkbox-group {
      padding-bottom: 20px;
      border-bottom: 1px dashed #ccc;
    }
    .tag-box + .tag-box {
      margin-top: 20px;
    }
    .input-new-tag {
      width: 68px;
      margin-left: 25px;
    }
    .button-new-tag {
      margin-left: 25px;
    }
    .checkbox-delete {
      margin-left: 5px;
      background-color: #989898;
      color: white;
      border-radius: 50%;
      text-align: center;
    }
  }
}
</style>
